"use client";
import { useState } from "react"
import { ForecastSummary } from "./Components/ForecastSummary/ForecastSummary";
import { PivotalDeals } from "./Components/PivotalDeals/PivotalDeals";
import { FilterSection } from "./Components/FilterSection/FilterSection";
import { LeadoffChatBot } from "../reusable/LeadoffChatBot/LeadoffChatBot";
import type { DateRange } from "react-day-picker"
import { subMonths } from "date-fns"
import styled from "styled-components"
import LeadoffRobot from "static/svgs/LeadoffRobot";

// Mock forecast data
const mockForecastData = {
  target: 500000,
  committed: 350000,
  bestCase: 420000,
  pipeline: 1200000,
  closedWon: 280000,
  attainment: 56,
  previousPeriodChange: 12,
};

const ChatToggleButton = styled.button`
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #7CDF4D 0%, #4CABCA 100%);
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: white;
  font-size: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  transition: transform 0.2s, box-shadow 0.2s;
  z-index: 999;
  
  &:hover {
    transform: scale(1.05);
    box-shadow: 0 6px 25px rgba(0, 0, 0, 0.2);
  }
  
  &:active {
    transform: scale(0.95);
  }
  
  svg {
    width: 32px;
    height: 32px;
  }
`;

export default function ForecastPage() {
  // Filter states
  const [team, setTeam] = useState("all");
  const [salesRep, setSalesRep] = useState("all");
  const [dateRange, setDateRange] = useState<DateRange | undefined>({
    from: subMonths(new Date(), 3),
    to: new Date(),
  });
  const [forecastFilter, setForecastFilter] = useState("full");
  
  // Chat states
  const [isChatOpen, setIsChatOpen] = useState(false);
  
  // Combine all forecast data for chat context
  const forecastContext = {
    ...mockForecastData,
    filters: { team, salesRep, dateRange, forecastFilter }
  };
  
  return (
    <div className="">
      <div className="w-full bg-white rounded-tr-lg rounded-bl-lg rounded-br-lg shadow-lg px-8 py-8 space-y-6">
        <h1 className="text-3xl text-black font-bold">Sales Forecast</h1>
        <FilterSection
          team={team}
          setTeam={setTeam}
          salesRep={salesRep}
          setSalesRep={setSalesRep}
          dateRange={dateRange}
          setDateRange={setDateRange}
          forecastFilter={forecastFilter}
          setForecastFilter={setForecastFilter}
        />
        <ForecastSummary forecastData={mockForecastData} />
        <PivotalDeals />
      </div>
      
      {/* Chat Toggle Button */}
      {/* <ChatToggleButton onClick={() => setIsChatOpen(true)}>
        <LeadoffRobot />
      </ChatToggleButton>
      
   
      <LeadoffChatBot
        isOpen={isChatOpen}
        onClose={() => setIsChatOpen(false)}
        context="forecast"
        contextData={forecastContext}
        suggestions={[
          "Summarize the key risks in my current forecast.",
          "Which deals are most pivotal to hitting my target?",
          "What's the biggest change from the previous period?"
        ]}
        placeholder="Ask about your forecast data..."
      /> */}
    </div>
  );
}
